import { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger);

// Quiet-luxury scroll reveal (per DESIGN.md: slow fade + small lift, transform/
// opacity only — no bounce/scale). SEO- and a11y-safe: it does NOTHING during the
// react-snap prerender and for reduced-motion users, so content is always present
// and visible in the static HTML — GSAP only enhances real, motion-OK browsers.
//
//   <Reveal>…</Reveal>                  fade one block up on scroll
//   <Reveal stagger={0.08}>…children…</Reveal>   stagger direct children (grids)
export default function Reveal({
  children,
  as: Tag = 'div',
  y = 24,
  delay = 0,
  duration = 0.7,
  stagger = 0,
  start = 'top 85%',
  className = '',
}) {
  const ref = useRef(null);

  useGSAP(
    () => {
      const isPrerender = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
      const reduce = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      if (isPrerender || reduce || !ref.current) return; // leave content visible

      const targets = stagger ? ref.current.children : ref.current;
      gsap.from(targets, {
        opacity: 0,
        y,
        duration,
        delay,
        ease: 'power2.out',
        stagger: stagger || 0,
        scrollTrigger: { trigger: ref.current, start, once: true },
      });
    },
    { scope: ref }
  );

  return (
    <Tag ref={ref} className={className}>
      {children}
    </Tag>
  );
}
